import { Box, CircularProgress } from "@mui/material";

const LoadingInPage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        minHeight: "400px",
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default LoadingInPage;
